import { Button, Dialog, Icons, Intent, Size } from "construct-ui";
import fileInputComponent from "../../components/common/file-input-component";
import SingleSelectCommonComponentView from "../../components/common/single-select-common-component.view";
import NumberInputComponent from "../../components/number/number-input.component";
import fileModel from "../../models/common/file.model";
import modelBase from "../../models/model-base.model";
import ViewBase from "../view-base.view";
import QuestionTypeIconView from "./question-type-icon.view";
import { SURVEY_TYPES } from "../../config/constants";
import Sortable from 'sortablejs';

export default function SurveyQuestionsListView() {
  ViewBase.call(this);

  const ID_INPUT_QUESTION_TEXT = 'inputQuestionText';
  const ID_INPUT_QUESTION_HINT = 'inputQuestionHint';
  const TEXT_INPUT_FUNCTIONALITIES = [
    {
      icon: 'bi-link-45deg',
      placeholder: '[Input Name Here](Input URL Here)'
    }
  ]

  let onAdd = () => { };
  let onClosed = () => { };
  let onDelete = () => { };
  let onEdit = () => { };

  let isShow = false;
  let _base64Image = "";
  let _isPreviewOpen = false;
  let isSubmitted = false;
  let photoFilter = {
    photo: {},
    photoForm: null,
    photoGuid: '00000000-0000-0000-0000-000000000000'
  };
  let parentOptionList = [];
  let _attachment = { file: undefined, filename: '', fileID: '' };
  let parentQsList = [];
  let selectedParentCode = "";
  let maxQnId = 0;
  let surveyIdString = "";
  
  let yesnoOptions = [{ name: "Yes", code: "Y" }, { name: "No", code: "N" }];
  let photoNumberOptions = [{ name: "1", code: "1" }, { name: "2", code: "2" }, { name: "3", code: "3" }, { name: "4", code: "4" }];
  let question = {
    questionText: "",
    code: "",
    usedYN: { code: "Y", name: "Yes" },
    mandatory: { code: "N", name: "No" },
    parentQuestion: { code: "", name: "" },
    parentAnsId: { code: "", name: "" },
    questionType: { code: "", name: "" },
    photoNumberLimit: { code: "", name: "" },
    ratingWordsMax: "",
    ratingWordsMin: "",
    questionHint: "",
    optionList: [],
    sequence: '',
    index: 0,
    oldSequence: 0,
    photoGuid: "",
    minValue: null,
    maxValue: null
  };
  let isEdit = false;
  let isValidSequence = true;
  // let sortable;

  let _filePreview = (fileMasterId) => {
    fileModel.getSurveyImageFile(
      (result) => {
        _isPreviewOpen = true;
        _base64Image = result.fileContent;
      },
      (error) => {
        this.handleError(error);
      },
      fileMasterId
    )
  }

  let createGuid = () => {
    return Math.floor(Math.random() * 1000000);//generate in between 0 and 1000000
  }

  let _goBack = () => {
    onClosed();
  }

  let _removeItem = (item) => {
    question.optionList = question.optionList.filter(x => x.code != item.code);
  }

  let _getRadioItemsWithSequence = () => {
    let items = document.querySelectorAll('#radioList > li');
    let seq = 1;
    let dtValues = [];
    items.forEach(item => {
      let inputList = item.querySelectorAll('input')
      let radioValues = { name: "", sequence: "", code: "" };
      let txtValue = inputList[0].value;
      let txtId = inputList[1].value;
      radioValues["name"] = txtValue;
      radioValues["sequence"] = seq.toString();
      radioValues["code"] = txtId;

      dtValues.push(radioValues);
      seq++;
    });
    question.optionList = [];
    question.optionList = dtValues;
    return dtValues;
  }

  let _isValidAll = (questions) => {
    if (question.questionText == "" || question.usedYN.code == "" || question.mandatory.code == "" || question.questionType.code == "") {
      return false;
    }
    if (question.sequence == '' || question.sequence == 0) {
      return false;
    }
    if (question.questionType.code == "0002" || question.questionType.code == "0003" || question.questionType.code == "0008" || question.questionType.code == "0009") {
      if (question.optionList.length == 0) {
        return false;
      }
    }

    if (question.parentQuestion.code != "") {
      if ((selectedParentCode == "0002" || selectedParentCode == "0003" || selectedParentCode == "0008" || selectedParentCode == "0009") && question.parentAnsId.code == "") {
        return false;
      }
    }

    if (question.questionType.code == "0004") {
      if (question.photoNumberLimit.code == "") {
        return false;
      }
    }

    if (question.questionType.code == "0012") {
      if (question.ratingWordsMax == "" || question.ratingWordsMin == "") {
        return false;
      }
    }
    if (question.questionType.code == "0005") {
      if (isMinGreaterThanMax(question.minValue, question.maxValue)) {
        return false;
      }
    }
    if (!isEdit && questions.length > 0) {
      let sameSeqCount = questions.filter(x => x.sequence.toString() == question.sequence.toString()).length;
      isValidSequence = sameSeqCount == 0 ? true : false;
      if (sameSeqCount > 0) {
        isValidSequence = false;
        return false;
      }
    }
    return true;
  }

  const isMinGreaterThanMax = (min, max) => {
    return (min != null && max != null && min > max);
  }

  let _getSortedOptionList = (optionList, code) => {
    let list = [];
    optionList.sort((a, b) => a.sequence - b.sequence);
    if (code == "0011" && optionList.length == 0) {
      list.push({ name: 'Yes', code: '1' });
      list.push({ name: 'No', code: '2' });
    } else {
      optionList.forEach(function (item) {
        list.push({
          name: item.name,
          code: item.code
        });
      });
    }

    return list;
  }

  let fileChange = (e, question) => {
    _attachment.file = e.files[0];
    _attachment.filename = e.files[0].name;
    photoFilter.photoGuid = e.files[0].name;
    photoFilter.photo = _attachment;
    photoFilter.photoForm = new FormData();
    photoFilter.photoForm.append("file", e.files[0]);

    modelBase.uploadfile((result) => {
      photoFilter.photoGuid = result[0].id;
      question.photoGuid = result[0].id;
    }, (error) => {
      log.e(error);
    }, photoFilter.photo?.file, 'Survey');
  }

  let fileClear = () => {
    _attachment.file = [];
    _attachment.filename = "";
    photoFilter.photo = null;
    photoFilter.photoForm = null;
    photoFilter.photoGuid = '00000000-0000-0000-0000-000000000000';
  }

  let _setItemForUpdate = (questions, item, index) => {
    if (item.parentQuestion.code != "") {
      let parentItem = questions.filter(x => x.code == item.parentQuestion.code)[0];
      selectedParentCode = parentItem.questionType.code;
      if (selectedParentCode == "0002" || selectedParentCode == "0003" || selectedParentCode == "0008" || selectedParentCode == "0009" || selectedParentCode == "0011") {
        parentOptionList = _getSortedOptionList(parentItem.optionList, selectedParentCode);
      }
    } else {
      parentOptionList = [];
    }
    question.questionText = item.questiontext;
    question.usedYN = { ...item.usedYN };
    question.mandatory = { ...item.mandatory };
    question.parentQuestion = { ...item.parentQuestion };
    question.parentAnsId = { ...item.parentAnsId };
    question.sequence = item.sequence;
    question.optionList = item.optionList;
    question.code = item.code;
    question.index = index;
    question.questionType = { ...item.questionType };
    question.oldSequence = item.sequence;
    question.photoGuid = item.photoGuid;
    photoFilter.photoGuid = item.photoGuid;
    question.photoNumberLimit = { ...item.photoNumberLimit };
    question.ratingWordsMax = item.ratingWordsMax;
    question.ratingWordsMin = item.ratingWordsMin;
    question.questionHint = item.questionHint;
    question.minValue = item.minValue;
    question.maxValue = item.maxValue;
    isEdit = true;
  }

  let _clearFilledQuestion = () => {
    selectedParentCode = "";
    parentOptionList = [];
    isSubmitted = false;
    question = {
      questionText: "",
      code: "",
      usedYN: { code: "Y", name: "Yes" },
      mandatory: { code: "N", name: "No" },
      parentQuestion: { code: "", name: "" },
      parentAnsId: { code: "", name: "" },
      questionType: { code: "", name: "" },
      optionList: [],
      index: 0,
      sequence: '',
      oldSequence: 0,
      photoGuid: "",
      photoNumberLimit: { code: "", name: "" },
      ratingWordsMax: "",
      ratingWordsMin: "",
      questionHint: "",
      minValue: null,
      maxValue: null
    };
    photoFilter.photoGuid = "00000000-0000-0000-0000-000000000000";
    photoFilter.photo = {};
    photoFilter.photoForm = null;
    isEdit = false;
  }

  let _addQuestion = (questions) => {
    isSubmitted = true;
    if (_isValidAll(questions)) {
      _getRadioItemsWithSequence();
      let strMaxId = (maxQnId + 1).toString();
      let obj = structuredClone({
        code: !isEdit ? strMaxId : question.code,
        questiontext: question.questionText,
        usedYN: question.usedYN,
        mandatory: question.mandatory,
        parentQuestion: question.parentQuestion,
        questionType: question.questionType,
        parentAnsId: question.parentAnsId,
        optionList: question.optionList,
        sequence: question.sequence,
        photoGuid: question.photoGuid,
        questionHint: question.questionHint,
        ratingWordsMin: question.ratingWordsMin,
        ratingWordsMax: question.ratingWordsMax,
        photoNumberLimit: question.photoNumberLimit,
        minValue: question.minValue,
        maxValue: question.maxValue
      });
      if (!isEdit) {
        maxQnId = Number(strMaxId);
        onAdd(obj);
      } else {
        onEdit(question.index, obj, question.oldSequence);
        isEdit = false;
      }
      isValidSequence = true;
      selectedParentCode = "";
      parentOptionList = [];
      isSubmitted = false;
      question = {
        questionText: "",
        code: "",
        usedYN: { code: "Y", name: "Yes" },
        mandatory: { code: "N", name: "No" },
        parentQuestion: { code: "", name: "" },
        parentAnsId: { code: "", name: "" },
        questionType: { code: "", name: "" },
        optionList: [],
        index: 0,
        sequence: (questions.length + 1),
        oldSequence: 0,
        photoGuid: "",
        photoNumberLimit: { code: "", name: "" },
        ratingWordsMax: "",
        ratingWordsMin: "",
        questionHint: "",
        minValue: null,
        maxValue: null
      };
      photoFilter.photoGuid = "00000000-0000-0000-0000-000000000000";
      photoFilter.photo = {};
      photoFilter.photoForm = null;
    }
  }

  const displayQuestionHint = (code) => {
    return (code !== '0002' && code !== '0003' && code !== '0011' && code !== '0012')
  }

  const appendPlaceholderIntoElement = (elementId, placeholder) => () => {
    const input = document.getElementById(elementId);
    const selectionEnd = input.selectionEnd;
    input.value = input.value.substring(0, selectionEnd) + placeholder + input.value.substring(selectionEnd);
    input.selectionEnd = selectionEnd + placeholder.length;
    input.dispatchEvent(new Event('change'));
    input.focus();
  }

  const InputComponentsForSingleMultipleType = () => {
    return {
      oncreate:() => {
        const radioList = document.getElementById("radioList");
        new Sortable(radioList, {
          animation: 150,
          ghostClass: 'sortable-ghost',
          dragClass: 'sortable-drag',
          handle: '.drag-grip',
        });  
      },
      onupdate:() => {
        if(question.optionList && question.optionList.length > 0) {
          const radioList = document.getElementById("radioList");
          new Sortable(radioList, {
            animation: 150,
            ghostClass: 'sortable-ghost',
            dragClass: 'sortable-drag',
            handle: '.drag-grip',
          }); 
        }
      },
      view: () => [
        m('.col-12',
          m('.card',
            m('.card-body',
              (question.optionList && question.optionList.length > 0)
                ? m('ul[id="radioList"].moveable_background-none.p-0.m-0',
                  question.optionList.map(dtVal => [
                    m('li.drag-grip',
                      m('.d-flex.gap-1.align-items-center',
                        m('i.bi-grip-vertical.pe-1'),
                        m('.flex-grow-1',
                          m("input[type='text']", {
                            "class": "form-control form-control-bg",
                            value: dtVal.name,
                            onkeyup: e => {
                              if (e.key != ">" && e.key != "|") {
                                dtVal.name = e.target.value;
                              }
                            }
                          }),
                          m('input[type="hidden"][value="' + dtVal.code + '"]')
                        ),
                        m('.flex-shrink-0',
                          m(Button, {
                            iconLeft: Icons.MINUS_CIRCLE,
                            iconLeftAttrs: {
                              size: Size.XL
                            },
                            intent: Intent.NEGATIVE,
                            label: "",
                            title: this.getText("LT00000237", "Remove"),
                            basic: true,
                            size: Size.SM,
                            onclick: () => { _removeItem(dtVal) }
                          }),
                        )
                      )
                    )
                  ])
                )
                : m('.text-center.my-2', { style: "color: var(--grey-color-dark)" },
                  m('small', this.getText("LT00000507", "Click '+ Add' to start adding..."))
                ),
              m('.mt-3.text-end',
                m(Button, {
                  iconLeft: Icons.PLUS,
                  intent: Intent.PRIMARY,
                  label: this.getText("LT00000090", "Add"),
                  outlined: true,
                  rounded: true,
                  size: Size.XS,
                  onclick: () => {
                    question.optionList.push({ name: "", code: createGuid(), value: "" });
                  }
                }),
              ),
              (isSubmitted && question.optionList.length == 0) &&
              m('.invalid-feedback.d-block',
                m('small', this.getText("EM00000362", "Please add option types"))
              )
            )
          )
        )
      ]
    }
  }

  const InputComponentsForPhotoType = () => {
    return {
      view: () => [
        m('.col-md-12',
          m('label.form-label.mandatory', this.getText("LT00000508", "Photo Count")),
          m(SingleSelectCommonComponentView, {
            disabled: false, iconList: [], items: photoNumberOptions, selectedItem: question.photoNumberLimit, handleSelect: (sItem) => {
              question.photoNumberLimit = sItem;
            }
          }),
          (isSubmitted && question.photoNumberLimit.code == "") &&
          m('.invalid-feedback.d-block',
            m('small', this.getText("EM00000363", "Please select number of photos"))
          )
        )
      ]
    }
  }

  const InputComponentsForRatingType = () => {
    return {
      view: () => [
        m('.col-md-12',
          m('.col-md-12',
            m('label.form-label.mandatory', this.getText("LT00000509", "Rating Words Min")),
            m("input", {
              "class": "form-control form-control-bg", "type": "text", "value": question.ratingWordsMin,
              onchange: (e) => {
                if (e.target.value == "") {
                  question.ratingWordsMin = "";
                } else {
                  question.ratingWordsMin = e.target.value;
                }
              }
            }
            )),
          m('.col-md-12',
            m('label.form-label.mandatory', this.getText("LT00000510", "Rating Words Max")),
            m("input", {
              "class": "form-control form-control-bg", "type": "text", "value": question.ratingWordsMax,
              onchange: (e) => {
                if (e.target.value == "") {
                  question.ratingWordsMax = "";
                } else {
                  question.ratingWordsMax = e.target.value;
                }
              }
            })
          ),
          (isSubmitted && (question.ratingWordsMin == "" || question.ratingWordsMax == "")) &&
          m('.invalid-feedback.d-block',
            m('small', this.getText("EM00000364", "Please provide rating scale min and max words"))
          )
        )
      ]
    }
  }

  const InputComponentsForUseYNType = () => {
    return {
      view: () => [
        m('.col-md-12',
          m('label.form-label.mandatory', this.getText("LT00000359", "Used YN")),
          m(SingleSelectCommonComponentView, {
            disabled: false, iconList: [], items: yesnoOptions, selectedItem: question.usedYN, handleSelect: (sItem) => {
              question.usedYN = sItem;
            }
          }),
          (isSubmitted && question.usedYN.code == "") &&
          m('.invalid-feedback.d-block',
            m('small', this.getText("EM00000365", "Please select UsedYN value"))
          )
        )
      ]
    }
  }

  const SectionQuestionList = () => {
    return {
      view: ({ attrs: {
        questions = []
      } }) => [
          m(".card",
            m('.card-body.question-list-container',
              m('.row',
                !(questions?.length > 0) &&
                m('.col-12.text-center.py-5',
                  m('p', this.getText("EM00000367", "No questions added")),
                  m('p', this.getText("EM00000368", "Please use the form on the left to create new questions")),
                ),
                questions?.map((item, index) =>
                  m('.col-xxl-6.mb-3',
                    m('.card.survey-Questions-bk',
                      m('.card-body',
                        m('.d-flex.align-items-top',
                          m(QuestionTypeIconView, { question: item }),
                          m('.flex-shrink-0.pe-2.text-center', { style: "border-right: 1px solid lightgray; min-width: 42px;" },
                            m('span.span-badge', item.sequence),
                          ),
                          m('.flex-grow-1.overflow-hidden.px-2', m('p.m-0', item.questiontext)),
                          m('.d-flex.justify-content-end.gap-2',
                            m(Button, {
                              iconLeft: Icons.EDIT_2,
                              intent: Intent.PRIMARY,
                              outlined: true,
                              rounded: true,
                              size: Size.XS,
                              onclick: () => {
                                _setItemForUpdate(questions, item, index);
                              }
                            }),
                            m(Button, {
                              iconLeft: Icons.TRASH,
                              intent: Intent.NEGATIVE,
                              outlined: true,
                              rounded: true,
                              disabled: parseInt(surveyIdString) < 0,
                              size: Size.XS,
                              onclick: () => {
                                onDelete(index);
                              }
                            })
                          )
                        )
                      )
                    )
                  )
                )
              ),
            )
          ),
        ]
    }
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.onClosed) {
        onClosed = vnode.attrs.onClosed;
      }

      if (vnode.attrs.onAdd) {
        onAdd = vnode.attrs.onAdd;
      }

      if (vnode.attrs.onDelete) {
        onDelete = vnode.attrs.onDelete;
      }

      if (vnode.attrs.onEdit) {
        onEdit = vnode.attrs.onEdit;
      }

      if (vnode.attrs.maxQnId) {
        maxQnId = vnode.attrs.maxQnId;
      }

      if (vnode.attrs.surveyIdString) {
        surveyIdString = vnode.attrs.surveyIdString;
      }
    },
    oncreate: () => {
      document.getElementById('sequence').addEventListener("keydown", (event) => {
        if (isNaN(event.key) || Number(event.key) < 0) {
          event.preventDefault();
          return;
        }
        return true;
      });
    },
    onupdate: function (vnode) {
      parentQsList = [];
      if (vnode.attrs.subSurvey) {
        vnode.attrs.subSurvey.questions.sort((a, b) => a.sequence - b.sequence);
        vnode.attrs.subSurvey.questions.forEach(function (item) {
          if ((question.code != item.code) && (item.questionType.code == "0002" || item.questionType.code == "0003" || item.questionType.code == "0008" || item.questionType.code == "0009" || item.questionType.code == "0011")) {
            parentQsList.push({
              name: item.questiontext,
              code: item.code
            });
          }
        });
      }
    },
    view: (vnode) => {
      if (vnode.attrs.subSurvey) {
        vnode.attrs.subSurvey.questions.sort((a, b) => a.sequence - b.sequence);
      }

      return [
        m('.row',
          m(".col-12",
            m('.d-flex.mb-3',
              m('h1.mb-2', m('i.bi.bi-arrow-left.cursor-pointer', {
                onclick: () => {
                  _goBack();
                }
              })),
              m('.flex-grow-1',
                m('h1.mb-2', vnode.attrs.subSurvey.name)
              ),
            ),
            m(".row.g-3",
              // Section: Add question
              m('.col-md-5.col-xl-4',
                m(".card",
                  m('.card-body.question-form-container',
                    m('.row.g-3',
                      m('.col-12',
                        m('div.hstack.justify-content-between',
                          m('label.form-label.mandatory', this.getText("LT00000358", "Question Text")),
                          vnode.attrs.surveyType === SURVEY_TYPES.PUBLIC && m('div.btn-group.mb-2',
                            TEXT_INPUT_FUNCTIONALITIES
                              .map(symbol => m('button.btn.btn-white.btn-sm', { onclick: appendPlaceholderIntoElement(ID_INPUT_QUESTION_TEXT, symbol.placeholder) },
                                m(`i.bi.m-0.fs-6.${symbol.icon}`)
                              ))
                          )
                        ),
                        m(`textarea#${ID_INPUT_QUESTION_TEXT}.form-control`, {
                          value: question.questionText,
                          onchange: (e) => { question.questionText = e.target.value }
                        }),
                        (isSubmitted && question.questionText == "") &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000360", "Please enter question text"))
                        )
                      ),
                      m('.col-12',
                        m('label.form-label.mandatory', this.getText("LT00000361", "Question Type")),
                        m(SingleSelectCommonComponentView, {
                          disabled: false,
                          iconList: vnode.attrs.iconList,
                          items: vnode.attrs.questionTypeList,
                          selectedItem: question.questionType,
                          handleSelect: (sItem) => {
                            question.questionType = sItem;
                          }
                        }),
                        (isSubmitted && question.questionType.code == "") &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000361", "Please select question type"))
                        )
                      ),
                      (question.questionType.code == "0002" || question.questionType.code == "0003" || question.questionType.code == "0008" || question.questionType.code == "0009") &&
                      m(InputComponentsForSingleMultipleType),
                      question.questionType.code == "0004" &&
                      m(InputComponentsForPhotoType),
                      question.questionType.code == "0012" &&
                      m(InputComponentsForRatingType),
                      isShow &&
                      m(InputComponentsForUseYNType),
                      m('.col-md-12',
                        m('label.form-label.mandatory', this.getText("LT00000115", "Mandatory")),
                        m(SingleSelectCommonComponentView, {
                          disabled: false, iconList: [], items: yesnoOptions, selectedItem: question.mandatory, handleSelect: (sItem) => {
                            question.mandatory = sItem;
                          }
                        }),
                        (isSubmitted && question.mandatory.code == "") &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000366", "Please select Mandatory value"))
                        )
                      ),
                      m('.col-md-12',
                        m('label.form-label', this.getText("LT00000360", "Parent Question")),
                        m(SingleSelectCommonComponentView, {
                          disabled: false, iconList: [], items: parentQsList, selectedItem: question.parentQuestion, handleSelect: (sItem) => {
                            question.parentQuestion = sItem;
                            let parentItem = vnode.attrs.subSurvey.questions.filter(x => x.code == sItem.code)[0];
                            selectedParentCode = parentItem.questionType.code;
                            if (selectedParentCode == "0011") {
                              parentOptionList = _getSortedOptionList(parentItem.optionList, selectedParentCode);
                            }
                            else if (parentItem.optionList.length > 0) {
                              parentOptionList = _getSortedOptionList(parentItem.optionList, selectedParentCode);
                            }
                          }
                        }),
                      ),
                      parentOptionList.length > 0 &&
                      m('.col-md-12',
                        m('label.form-label', this.getText("LT00000511", "Parent Answer")),
                        m(SingleSelectCommonComponentView, {
                          disabled: false, iconList: [], items: parentOptionList, selectedItem: question.parentAnsId, handleSelect: (sItem) => {
                            question.parentAnsId = sItem;
                          }
                        }),
                        (isSubmitted && (selectedParentCode == "0002" || selectedParentCode == "0003" || selectedParentCode == "0008" || selectedParentCode == "0009") && question.parentAnsId.code == "") &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000360", "Please enter question text"))
                        )
                      ),
                      m('.col-md-12',
                        m('label.form-label.mandatory', this.getText("LT00000512", "Sequence")),
                        m("input.form-control#sequence", {
                          type: "number",
                          min: "1",
                          value: question.sequence,
                          onchange: (e) => {
                            question.sequence = e.target.value;
                          }
                        }),
                        (isSubmitted && (question.sequence == '' || question.sequence == 0)) &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000398", "Please enter the sequence"))
                        ),
                        (isSubmitted && !isValidSequence) &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000397", "Duplicated sequence are not allowed"))
                        )
                      ),
                      question.questionType.code == "0005" && m('.col-md-12',
                        m('label.form-label', this.getText("LT00000582", "Minimum Value")),
                        m(NumberInputComponent, {
                          id: 'minValue',
                          value: question.minValue,
                          onChange: (value) => {
                            question.minValue = isNaN(value) ? null : value;
                          }
                        })
                      ),
                      question.questionType.code == "0005" && m('.col-md-12',
                        m('label.form-label', this.getText("LT00000583", "Maximum Value")),
                        m(NumberInputComponent, {
                          id: 'maxValue',
                          value: question.maxValue,
                          onChange: (value) => {
                            question.maxValue = isNaN(value) ? null : value;
                          }
                        }),
                        (question.questionType.code == "0005" && isSubmitted && isMinGreaterThanMax(question.minValue, question.maxValue)) &&
                        m('.invalid-feedback.d-block',
                          m('small', this.getText("EM00000399", "Maximum value should be greater than minimum value"))
                        )
                      ),
                      m(fileInputComponent, {
                        label: this.getText("LT00000259", "Photo"),
                        accept: '.png,.jpeg,.jpg',
                        onchange: (e) => { fileChange(e, question) },
                        onClear: () => { question.photoGuid = ""; fileClear(); },
                        onPreview: (id) => {
                          _filePreview(id);
                        },
                        fileID: question.photoGuid

                      }),
                      displayQuestionHint(question.questionType.code) && m('.col-md-12',
                        m('div.hstack.justify-content-between',
                          m('label.form-label.mandatory', this.getText("LT00000513", "Question hint")),
                          vnode.attrs.surveyType === SURVEY_TYPES.PUBLIC && m('div.btn-group.mb-2',
                            TEXT_INPUT_FUNCTIONALITIES
                              .map(symbol => m('button.btn.btn-white.btn-sm', { onclick: appendPlaceholderIntoElement(ID_INPUT_QUESTION_HINT, symbol.placeholder) },
                                m(`i.bi.m-0.fs-6.${symbol.icon}`)
                              ))
                          )
                        ),
                        m(`textarea#${ID_INPUT_QUESTION_HINT}.form-control.form-control-bg`, {
                          value: question.questionHint,
                          onchange: (e) => { question.questionHint = e.target.value }
                        }),
                      ),
                    ),
                  ),
                  m('.card-body', { style: 'border-top: 1px solid var(--blue-color-light);' },
                    m('.d-flex.gap-2.justify-content-end.my-2',
                      m(Button, {
                        iconLeft: isEdit ? Icons.EDIT_2 : Icons.PLUS,
                        intent: Intent.PRIMARY,
                        label: isEdit ? this.getText("LT00000498", "Update") : this.getText("LT00000514", "Add Question"),
                        rounded: true,
                        disabled: parseInt(surveyIdString) < 0,
                        size: Size.XS,
                        onclick: () => {
                          isValidSequence = true;
                          _addQuestion(vnode.attrs.subSurvey.questions);
                        }
                      }),
                      m(Button, {
                        intent: Intent.PRIMARY,
                        label: this.getText("LT00000031", "Clear"),
                        outlined: true,
                        rounded: true,
                        size: Size.XS,
                        onclick: () => {
                          _clearFilledQuestion();
                        }
                      }),
                    ),
                  )
                )
              ),
              // Section: Question list
              m('.col-md-7.col-xl-8 ',
                m(SectionQuestionList, { questions: vnode.attrs.subSurvey.questions }),
              ),
            )
          )
        ),
        m(Dialog, {
          isOpen: _isPreviewOpen,
          onClose: () => { _isPreviewOpen = false; },
          transitionDuration: 200,
          closeOnOutsideClick: false,
          title: this.getText("LT00000499", "Image Preview"),
          content: m('img[src="' + _base64Image + '"]', { "style": "width:100%;height:100%" }),
          "class": "cui-dialog-sm"
        }),
        this.getBaseViews()
      ];
    }
  }
}
